export default __webpack_public_path__ + "static/media/meslay10.90769f84.jpg";